import { Resource } from './resource';

export class ResourceForSaving extends Resource {

    /**
        * Set to true if it is okay to possibly save a duplicate resource.
        */
    skipUniquenessChecks: boolean;
}